const ImagesFactory = require('../../../factory/images');

const Element = require('./abstract/element');
const StickerGetter = require('./sticker');

module.exports = Logo;

function Logo () {}
Logo.prototype = new Element();
Logo.prototype.constructor = Logo;

Logo.prototype.initialize = function () {
  Element.prototype.initialize.call(this);
  this.stickerGetter = new StickerGetter();
  this.stickerGetter.initialize();

  this.structure = _.extend(this.structure, {
    is_vector: null,
    thumb_src: null,
    shapes: [{
      id: null,
      type: null,
      fill: {
        color: null,
        colorGroup: null
      },
      stroke: {
        color: null,
        width: null,
        dasharray: null
      }
    }]
  });
};

Logo.prototype.get = function (element) {
  const image = $(element).is('image')
    ? element
    : $(element).children('image')[0];

  const vector = !image && element;

  this.element = element;
  this.bb = element.getBBox();

  this.stickerGetter.element = vector;
  this.stickerGetter.bb = vector && vector.getBBox();

  this.stickerGetter.data = this.data = {};
  this.stickerGetter.collections = this.collections = {};
  this.stickerGetter.processData = this.processData = {};

  const originalStructure = this.structure;

  if (!vector) {
    this.structure = _.omit(this.structure, 'texts', 'shapes');
  }

  const result = Element.prototype.get.apply(this, arguments);
  this.structure = originalStructure;

  if (result.is_vector && !result.thumb_src) {
    result.thumb_src = $(element).attr('data-thumb-src');
  }

  return result;
};

Logo.prototype.getIsVector = function () {
  return !!this.stickerGetter.element;
};

Logo.prototype.getThumbSrc = function () {
  const image = $(this.element).is('image')
    ? this.element
    : $(this.element).children('image')[0];

  return image ? ImagesFactory.getOriginalUrl(image.getAttribute('xlink:href')) : null;
};

Logo.prototype.getShapes = function () {
  return this.stickerGetter.getShapes();
};

Logo.prototype.getElementsByColorGroup = StickerGetter.prototype.getElementsByColorGroup;
